// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"1b481835","718":"e6151dbd","742":"fe0e71cf","924":"baa72d29"}[chunkId] + ".chunk.js";
};